var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"infoDiv",on:{"click":_vm.onRowClick}},[_c('i',{staticClass:"fas fa-info-circle-solid fa-lg",attrs:{"id":"infoIcon","description":"info"}})])}
var staticRenderFns = []

export { render, staticRenderFns }